import {DataObject} from './data-object.model';

export class Patient extends DataObject {

    public readonly urlName = 'patient';

    public firstname: string;
    public lastname: string;
    public gender: string;
    public birthdate: Date;

    public fromObject(obj: any): Patient {
        this._id = obj.id;
        this.firstname = obj.firstname;
        this.lastname = obj.lastname;
        this.gender = obj.gender;
        this.gender = obj.birthdate;
        return this;
    }

    public toJSON() {
        return {
            firstname: this.firstname,
            lastname: this.lastname,
            gender: this.gender,
            birthdate: this.birthdate
        };
    }

}
